import { FC } from 'react';

import { formatShippingAddress } from '../../../utils/format';
import { FormItem, FormStateSelectItem } from '../../../hooks/common/useForm';
import { OnChangeFormInput, OnBlurFormInput } from '../../../hooks/common/useForm';

import style from './index.module.css';

export const Form: FC<{ 
  state: FormItem[],
  onChange: OnChangeFormInput,
  onBlur: OnBlurFormInput,
}> = ({ state, onChange, onBlur }) => {

  return (
    <form className={style.form}>
      {state.map((item, index) => (
        <div className={style.column}>
          <label key={index} className={style.label}>
            <span className={style.title}>
              {formatShippingAddress(item.name)}
              {item.status === 'pass' && <i>OK</i>}
            </span>
            <Input item={item} onChange={onChange} onBlur={onBlur}></Input>
          </label>
          {item.status === 'error' && (
            <span className={style.error}>{item.error}</span>
          )}
        </div>
      ))}
    </form>
  );
}

const Input: FC<{
  item: FormItem,
  onChange: OnChangeFormInput,
  onBlur: OnBlurFormInput,
}> = ({ item, onChange, onBlur }) => {

  if (!item) return <></>;

  if (item.type === 'text') {
    return (
      <input
        className={style.input}
        type={item.type}
        placeholder={item.placeholder}
        name={item.name}
        value={item.value}
        onChange={onChange}
        onBlur={onBlur}
      ></input>
    )
  } else if (item.type === 'select') {
    if (!item.items) return <></>;
    const items = item.items as FormStateSelectItem[];

    return (
      <select className={style.select} name={item.name} value={item.value} onChange={onChange} onBlur={onBlur}>
        <option value={""}>選択してください</option>
        {items.length > 0 && items.map(option => {
          const o = option as FormStateSelectItem;
          return <option value={o.value}>{o.name}</option>
        })}
      </select>
    )
  } else {
    return <></>;
  };
}